import type { AGUAppLocation } from '../app-surface/app-location';
import type { UserActivityPageDescriptor } from './user-activity-event';

/**
 * Page identity for the composable (Research Accelerator) surface: `module/view` plus the record when the view is a record view.
 *
 * A surface seeds `location` with `{ ModuleKey: '', View: '' }` before its composition resolves, and the
 * adapter's `Location$` emits that seed synchronously on subscribe. When BOTH fields are empty (after
 * trimming), there is no page yet — this returns `Page: ''` so the base surface can recognize and skip it,
 * rather than recording a spurious page view for `/`.
 */
export function DescribeAppLocation(location: AGUAppLocation): UserActivityPageDescriptor {
    if (location.ModuleKey.trim().length === 0 && location.View.trim().length === 0) {
        return { Page: '', RecordID: null };
    }
    return { Page: `${location.ModuleKey}/${location.View}`, RecordID: location.RecordID ?? null };
}
